import React from 'react'
import { cx } from 'class-variance-authority'

import type { GridToolbarProps } from '../types'

export function GridToolbar({
  children,
  variant = 'default',
  className,
}: GridToolbarProps) {
  return (
    <div
      className={cx(
        'flex min-w-0 flex-nowrap items-center justify-between',
        variant === 'compact' ? 'gap-3' : 'gap-4',
        className,
      )}
    >
      {children}
    </div>
  )
}
